import styled from "styled-components";

type TitlePartProps = {
  $color: string;
};

const Title = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const TitlePart = styled.span<TitlePartProps>`
  display: inline;
  color: ${({ $color, theme }) => theme.colors[$color]};
`;

const S = {
  Title,
  TitlePart,
};

export default S;
